import { LockOutlined, MailOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Input, Form } from "antd";
import React, { useState } from "react";
import { register } from "../API/Auth";

export interface RegisterFormProps {
  // Called on successful registration
  onRegister(): void;

  // Called on failure, parent should display an error
  onError(
    error: "account-already-exists" | "failure" | "connection-error"
  ): void;
}

export const RegisterForm: React.FunctionComponent<RegisterFormProps> = (
  props
) => {
  // State for loading spinner
  const [isLoading, setLoading] = useState<boolean>(false);

  // Create form instance
  const [form] = Form.useForm();

  // Called on form submission
  const onRegister = async () => {
    // Submit form to server
    setLoading(true);
    const result = await register(
      form.getFieldValue("email"),
      form.getFieldValue("password"),
      form.getFieldValue("fullName")
    );
    setLoading(false);

    if (result === "success") {
      props.onRegister();
    } else {
      props.onError(result);
    }
  };

  return (
    <Form
      hideRequiredMark={true}
      layout="vertical"
      form={form}
      onFinish={onRegister}
    >
      <Form.Item
        name="fullName"
        rules={[{ required: true, message: "Your name is required" }]}
      >
        <Input
          placeholder="Name"
          prefix={<UserOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
        />
      </Form.Item>

      <Form.Item
        name="email"
        rules={[
          {
            required: true,
            message: "An email address is required (used for login)!",
          },
        ]}
      >
        <Input
          type="email"
          placeholder="E-mail"
          prefix={<MailOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
        />
      </Form.Item>

      <Form.Item
        name="password"
        rules={[
          { required: true, message: "A password is required!" },
          {
            min: 8,
            message:
              "The password must be between 8 and 60 characters in length.",
          },
          {
            max: 60,
            message:
              "The password must be between 8 and 60 characters in length.",
          },
        ]}
      >
        <Input
          type="password"
          placeholder="Password"
          prefix={<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
        />
      </Form.Item>
      <Button
        type="primary"
        htmlType="submit"
        className="login-form-button"
        loading={isLoading}
      >
        Register Account
      </Button>
    </Form>
  );
};
